import Audios from "./audios";

export default Audios;
